export enum EntityNames {
    warehouses = "warehouses",
    cases = "cases",
    ranges = "ranges",
    accounts = "accounts",
    volumes = "volumes",
    deliveryMethods = "deliveryMethods",
    establishments = "establishments",
    rangesAndCases = "rangesAndCases",
    containers = "containers",
    audits = "audits",
    specimens = "specimens",
    outerCubes = "outerCubes",
    outerCubeTypes = "outerCubeTypes",
    packingBox = "packingBoxes",
    caseMaterials = "caseMaterials",
    customers = "customers",
    users = "users",
    operators = "operators",
    operatorSettings = "operatorSettings",
    operatorLevels = "operatorLevels",
    roles = "roles",
    invoices = "invoices",
    caseMaterialTypes = "caseMaterialTypes",
    orderNumberTypes = "orderNumberTypes",
    recalls = "recalls",
    customerRecalls = "customerRecalls",
    operatorRecalls = "operatorRecalls",
    recallInventory = "recallInventory",
    prefixes = "prefixes",
    accountAddresses = "accountAddresses",
    accountInvoices = "accountInvoices",
    accountOrderNumbers = "accountOrderNumbers",
    fileUploads = "fileUploads",
    sop = "SOP",
    certifications = "certifications",
    manuals = "manuals",
    priceLists = "priceLists",
    inventoryExports = "inventoryExports",
    reports = "Reports",
    recallLineItems = "recallLineItems",
    pickList = "pickList",
    pickListItem = "pickListItem",
    packaging = "packaging",
    couriers = "couriers",
    uplifts = "uplifts",
    operatorUplifts = "operatorUplifts",
    customerUplifts = "customerUplifts",
    operatorReturns = "operatorReturns",
    customerReturns = "customerReturns",
    returns = "returns",
    returnLineItems = "returnLineItems",
    workstations = "workstations",
    workstationOuterCubes = "workstationOuterCubes",
    partFullOuterCubes = "partFullOuterCubes",
    globalInvoices = "globalInvoices",
    invoiceTypes = "invoiceTypes",
    costMultipliers = "costMultipliers",
    storageSummary = "storageSummary",
    disposals = "disposals",
    disposalLineItems = "disposalLineItems",
    disposalChecks = "disposalChecks",
    locations = "locations",
    operatorStatuses = "operatorStatuses",
    userStatuses = "userStatuses",
    globalUsers = "globalUsers",
}